export const config = {
    recaptchaSiteKey: "6LcOmOoqAAAAAFKaMuOxfcd30S7si1PhKidTSGVR",
};
